import {parse as parseTeacher} from '@frontrow/console/src/entities/models/teacher'
import {type BaseTeacherAttrs as TeacherT} from '@frontrow/console/src/entities/models/teacher'
import {type SchoolAttrs, parseSchool} from '@frontrow/console/src/entities/models/school'

import {type DistrictT} from '@frontrow/console/src/models/district'
import {fromOpenApiDistrict} from '@frontrow/console/src/models/district'
import {type operations} from '@frontrow/console/src/open-api/fancy-api/generated-client'
import {type CamelCaseKeysOnly} from '@frontrow/console/src/open-api/clients'

export type TeacherWithAffiliationT = {
  teacher: TeacherT
  school: SchoolAttrs | undefined | null
  district: DistrictT | undefined | null
}

/** @internal */
export type TeacherWithAffiliationResponseT = Omit<TeacherWithAffiliationWire, 'school'> & {
  school?: CamelCaseKeysOnly<NonNullable<TeacherWithAffiliationWire['school']>> | null
}

type TeacherWithAffiliationWire =
  operations['getTeachersR']['responses'][200]['content']['application/json'][number]

export function parse(
  response: Array<TeacherWithAffiliationResponseT>
): Array<TeacherWithAffiliationT> {
  return response.map(parseModel)
}

/** @internal */
export function parseModel(response: TeacherWithAffiliationResponseT): TeacherWithAffiliationT {
  const {teacher, school, district} = response
  const parsedTeacherAttributes = parseTeacher(teacher)
  const parsedSchoolAttributes = school ? parseSchool(school) : null
  const parsedDistrictAttributes = district ? fromOpenApiDistrict(district) : null
  return {
    teacher: parsedTeacherAttributes,
    school: parsedSchoolAttributes,
    district: parsedDistrictAttributes
  }
}
